import React, { useMemo } from 'react';
import Ticker from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/ticker';
import useSanityPermissionsChecker from 'helpers/hooks/useSanityPermissionsChecker';

interface Props {
  data: any;
  customerGroup: any;
}

const TickerTastic: React.FC<Props> = ({ data, customerGroup }) => {
  const { checkNestedItemPermission } = useSanityPermissionsChecker();

  // Get cmsData from data (Sanity)
  const cmsData = data?.cmsData;
  const fields = cmsData?.dataSource?.fields;

  // Get all ticker components and filter by permissions
  const allowedTickers = useMemo(() => {
    // Check top-level permissions first
    if (fields?.userRoles) {
      const fieldsOnly = { userRoles: fields.userRoles };
      if (!checkNestedItemPermission(fieldsOnly, customerGroup)) {
        return [];
      }
    }

    // Get all components
    const components = fields?.components || [];
    if (!components || components.length === 0) {
      return [];
    }

    // Filter components that have permissions (checking all nested levels)
    return components.filter((component: any) => {
      return checkNestedItemPermission(component, customerGroup);
    });
  }, [fields, customerGroup, checkNestedItemPermission]);

  if (!allowedTickers?.length) return <></>;

  return (
    <>
      {allowedTickers.map((component: any, index: number) => {
        // Extract fields directly from Sanity component
        const firstText = component?.firstText;
        const textColor = component?.textColor;
        const repetitionFactor = component?.repetitionFactor;
        const backgroundColor = component?.backgroundColor;
        const heightBanner = component?.heightBanner;

        if (!firstText) return null;

        return (
          <Ticker
            key={component?._id || component?._system?.base?.id || index}
            firstText={firstText}
            textColor={textColor}
            repetitionFactor={repetitionFactor}
            backgroundColor={backgroundColor}
            heightBanner={heightBanner}
          />
        );
      })}
    </>
  );
};

export default TickerTastic;
